String.prototype.removeAccents = function () {
        return this
                .replace(/[áàãâä]/gi, "a")
                .replace(/[éè¨ê]/gi, "e")
                .replace(/[íìïî]/gi, "i")
                .replace(/[óòöôõ]/gi, "o")
                .replace(/[úùüû]/gi, "u")
                .replace(/[ç]/gi, "c")
                .replace(/[ñ]/gi, "n")
                .replace(/[^a-zA-Z0-9]/g, " ")
}

Object.defineProperty(Array.prototype, 'remove', {
  enumerable: false,
  value: function() {
        var what, a = arguments, L = a.length, ax
        while (L && this.length) {
                what = a[--L];
                while ((ax = this.indexOf(what)) !== -1) {
                        this.splice(ax, 1)
                }
        }
        return this
    }
});

String.prototype.contains = function(it) { return this.indexOf(it) != -1; }

String.prototype.lpad = function (width, z) {
  n = this
  n = n + ''        
  z = z || '0'
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}


// WEBPACK FOOTER //
// ./src/misc.js